var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,_vm._g(_vm._b({tag:"component",on:{"save-success":_vm.createSaveSuccess,"hiden-view":_vm.hiddenView,"close":_vm.hiddenView}},'component',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }